import { LogOut, Mail, Briefcase, CalendarDays } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LevelBadge } from "@/components/LevelBadge";
import { TeamLink } from "@/components/TeamLink";
import { CertificatesList } from "@/components/CertificatesList";
import { LanguageSettings } from "@/components/LanguageSettings";
import { ReminderSettings } from "@/components/ReminderSettings";
import { ChantierModeSettings } from "@/components/ChantierMode";
import { InstallCard } from "@/components/InstallCard";

export default function ProfilePage() {
  const { user, signOut } = useAuth();
  const rows = [
    [Briefcase, "Métier", user.trade, "profile-trade"],
    [Mail, "Email", user.email, "profile-email"],
    [CalendarDays, "Inscrit le", new Date(user.created_at).toLocaleDateString("fr-FR"), "profile-created"],
  ];
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4 rise">
        <div className="w-20 h-20 rounded-2xl bg-orange-500 grid place-items-center font-display text-4xl font-extrabold text-slate-900 uppercase">
          {user.name[0]}
        </div>
        <div>
          <h1 className="font-display text-4xl font-extrabold uppercase" data-testid="profile-name">{user.name}</h1>
          <LevelBadge level={user.level} testId="profile-level-badge" />
        </div>
      </div>
      <div className="bg-white rounded-2xl border-2 border-slate-200 divide-y rise rise-1">
        {rows.map(([Icon, l, v, id]) => (
          <div key={l} className="flex items-center gap-3 p-4">
            <Icon className="w-5 h-5 text-orange-600" />
            <span className="text-sm text-slate-500 w-24">{l}</span>
            <span className="font-semibold truncate" data-testid={id}>{v}</span>
          </div>
        ))}
      </div>
      <TeamLink testId="profile-team-link" />
      <CertificatesList />
      <LanguageSettings />
      <ReminderSettings />
      <ChantierModeSettings />
      <InstallCard testId="profile-install-card" />
      <p className="text-sm text-slate-600 rise rise-2">
        Le niveau s'adapte tout seul : 3/3 → niveau supérieur, moins de 2/3 → on consolide.
      </p>
      <button
        onClick={signOut}
        data-testid="profile-logout-btn"
        className="w-full h-14 rounded-xl border-2 border-slate-900 font-bold flex items-center justify-center gap-2 hover:bg-slate-900 hover:text-white transition-colors"
      >
        <LogOut className="w-5 h-5" /> Se déconnecter
      </button>
    </div>
  );
}
